module.exports = __webpack_public_path__ + "img/71.e22c1619.jpg";